import { BigNumber } from "bignumber.js";
export function initAccount(r) {
    var _a, _b;
    r.algorandResources = {
        rewards: new BigNumber(0),
        nbAssets: (_b = (_a = r.subAccounts) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0,
    };
}
//# sourceMappingURL=initAccount.js.map